import {
  VStack,
  AspectRatio,
  Text,
  Button,
  Link,
  Spacer,
  CSSObject,
  useBreakpointValue,
} from '@chakra-ui/react'
import Image from 'next/image'
import NextLink from 'next/link'

interface Props {
  title: string
  image: StaticImageData
  description?: string
  buttonLabel?: string
  href: string
  sx?: CSSObject
  onClick?: () => void
}

function Resource({
  image,
  title,
  description,
  buttonLabel,
  href,
  sx,
  onClick,
}: Props): React.ReactElement {
  const buttonSize = useBreakpointValue({ base: 'lg', sm: 'xl' })

  return (
    <VStack
      spacing=""
      sx={{
        bg: 'gray.50',
        px: { base: 6, sm: 11 },
        py: { base: 7, sm: 11 },
        maxW: '600px',
        alignItems: 'flex-start',
        ...sx,
      }}
    >
      {image && (
        <AspectRatio ratio={554 / 368} sx={{ w: 'full' }}>
          <Image
            src={image}
            alt={title}
            layout="fill"
            sizes="50%"
            placeholder="blur"
            quality={100}
          />
        </AspectRatio>
      )}
      <Text
        sx={{
          mt: { base: 6, sm: 8 },
          color: 'primary.400',
          fontWeight: 'bold',
          fontSize: { base: 'xl', sm: '3.5xl' },
        }}
      >
        {title}
      </Text>
      {description && (
        <Text sx={{ mt: 2, fontSize: { base: 'md', sm: '2xl' } }}>
          {description}
        </Text>
      )}
      <Spacer />
      <NextLink href={href} passHref>
        <Button
          as={Link}
          sx={{ mt: { base: 4, sm: 8 }, color: 'white !important' }}
          size={buttonSize}
          onClick={onClick}
        >
          {buttonLabel}
        </Button>
      </NextLink>
    </VStack>
  )
}

export default Resource
